// Carousel
// TODO photoMap
const photoMap = [
  {
    path: 'assets/images/people/01.jpg',
    motto: 'motto 1',
    info: 'info 1'
  },
  {
    path: 'assets/images/people/02.jpg',
    motto: 'motto 2',
    info: 'info 2'
  },
  {
    path: 'assets/images/people/03.jpg',
    motto: 'motto 3',
    info: 'info 3'
  },
  {
    path: 'assets/images/people/04.jpg',
    motto: 'motto 4',
    info: 'info 4'
  }
];

function stopSlide() {
  timerStop();
}
function startSlide() {
  timerStart();
}


var flips = document.getElementsByClassName('flipper-flip');

function goToNextSlide() {
  for (var i = 0; i < flips.length; i++) {
    if($(flips[i]).hasClass('flipper-flip_active')) {
      $(flips[i]).removeClass('flipper-flip_active');
      if(i < (flips.length - 1)) {
        $(flips[i+1]).addClass('flipper-flip_active');
        break;
      } else {
        $(flips[0]).addClass('flipper-flip_active');
        break;
      }
    }
  }
}

function flipFlop() {
  goToNextSlide();
}

// TIMER
let delay = 4000;
let intervalId;

function timerStop() {
  clearInterval(intervalId)
}

function timerStart() {
  timerStop(); // Stop timer by security, e.g. if you call `timerStart()` multiple times
  intervalId = setInterval(() => {
    goToNextSlide();
  }, delay)
}